<template>
  <div class="content">
    <h5-header :header-msg="headerMsg"></h5-header>

    <div class="state">
      <p
        :class="{col:detailObj.withdrawState == 3}"
      >{{detailObj.withdrawState == 1?'处理中(预计24小时到账)':detailObj.withdrawState == 2?'提现成功':'提现失败(已退回至您的账户)'}}</p>
      <p>￥{{detailObj.money}}</p>
    </div>

    <div class="msg">
      <p v-for="(item,index) in detailsList" :key="index">
        <span>{{item.key}}</span>
        <span>{{item.val}}</span>
      </p>
    </div>
  </div>
</template>

<script>
import { withdrawalDetail } from "@/api/picker/index";
export default {
  data() {
    return {
      headerMsg: {
        title: "提现详情",
        url: "/withdrawalRecords"
      },
      detailsList: [
        //详情数组
        {
          key: "当前状态",
          val: ""
        },
        {
          key: "提现金额",
          val: ""
        },
        {
          key: "申请时间",
          val: ""
        },
        {
          key: "退回时间",
          val: ""
        },
        {
          key: "到账账户",
          val: ""
        },
        {
          key: "提现单号",
          val: ""
        }
      ],
      id: "", //提现纪录id
      detailObj: {} //提现详情对象
    };
  },
  mounted() {
    this.id = this.$route.query.id;
    this.withdrawalDetail();
  },
  methods: {
    withdrawalDetail() {
      let obj = {
        token: this.$store.getters.token || this.GetQueryString("token"),
        id: this.id
      };
      withdrawalDetail(obj).then(res => {
        this.detailObj = res.content;
        this.detailsList[0].val =
          res.content.withdrawState == 1
            ? "处理中"
            : this.detailObj.withdrawState == 2
            ? "提现成功"
            : "提现失败";
        this.detailsList[1].val = "¥" + res.content.money;
        this.detailsList[2].val = res.content.createTime;
        this.detailsList[3].val =
          res.content == 3
            ? res.content.updateTime
            : res.content.accountingTime; //3为提现失败的失败时间
        this.detailsList[4].key =
          res.content.withdrawState == 3 ? "提现账户" : "到账账户";
        this.detailsList[4].val = res.content.memberName;
        this.detailsList[5].val = res.content.code;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.content {
  p {
    margin: 0;
  }
  .state {
    width: auto;
    height: 137px;
    margin: 0 12px 20px;
    border-bottom: 1px solid #f0f0f0;
    .col {
      color: #ec130c;
    }
    p:first-child {
      display: inline-block;
      color: #1d1d1d;
      font-size: 17px;
      margin-top: 32px;
    }
    p:last-child {
      color: #333;
      font-size: 40px;
      margin-top: 9px;
    }
  }
  .msg {
    text-align: left;
    p {
      width: auto;
      height: 20px;
      line-height: 20px;
      padding: 0 12px;
      display: flex;
      margin-bottom: 15px;
      span {
        font-size: 15px;
        display: block;
      }
      span:first-child {
        color: #666;
        margin-right: 45px;
      }
      span:last-child {
        color: #333;
      }
    }
  }
}
</style>

